var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { encodeData } from '../utils/qrcodeHandler';
export const RendererWrapper = (renderer) => {
    const Renderer = (props) => {
        let newProps = Object.assign({}, props);
        newProps.value = newProps.value || 'oss-ui';
        newProps.level = newProps.title || newProps.icon ? 'H' : newProps.level || 'M';
        newProps.qrcode =
            newProps.qrcode || encodeData({ text: newProps.value, correctLevel: newProps.level, typeNumber: -1 });
        newProps.styles = Object.assign(Object.assign({}, renderer.defaultCSS), props.styles);
        return React.createElement(renderer, newProps);
    };
    return Renderer;
};
export function drawIcon({ qrcode, title, titleSize, titleColor, titleAlign, icon, iconScale = 0.33, styles, }) {
    if (!qrcode)
        return [];
    if (!title && !icon)
        return null;
    const nCount = qrcode.getModuleCount();
    const _a = styles.title || {}, { fontSize, color, verticalAlign } = _a, titleStyle = __rest(_a, ["fontSize", "color", "verticalAlign"]);
    const titleVerticalAlign = titleAlign || verticalAlign || (icon ? 'bottom' : 'middle');
    iconScale = iconScale > 0.33 ? 0.33 : iconScale;
    const iconSize = Number(nCount * iconScale);
    const iconXY = (nCount - iconSize) / 2;
    const pointList = [];
    if (icon || titleVerticalAlign === 'middle') {
        pointList.push(<rect width={iconSize} height={iconSize} rx="2" ry="2" fill="#FFFFFF" x={iconXY} y={iconXY}/>);
    }
    if (icon) {
        pointList.push(<image xlinkHref={icon} width={iconSize - 2} x={iconXY + 1} y={iconXY + 1}/>);
    }
    if (title) {
        const svgWidth = styles.svg && styles.svg.width ? styles.svg.width.replace('px', '') : 300;
        const titleFontSize = (Number(nCount + (nCount / 5) * 2) * (titleSize || fontSize || 12)) / svgWidth;
        const titleFontColor = titleColor || color || '#000000';
        const fontY = titleVerticalAlign === 'middle'
            ? icon
                ? iconXY + iconSize
                : nCount / 2 + titleFontSize * 0.5
            : Number(nCount + nCount / 5) - titleFontSize * 0.5;
        pointList.push(<text x={nCount / 2} y={fontY} fill={titleFontColor} style={Object.assign(Object.assign({}, titleStyle), { fontSize: titleFontSize })} textAnchor="middle">
                {title}
            </text>);
    }
    return pointList;
}
